import {GameFont} from '../../../../shared/scripts/GameFont'
import {GameColor} from '../../../../shared/scripts/GameColor'
import {ItemCountView} from '../../../../shared/scripts/ui_canvas_engine/ItemCountView'
import {UIGamePlayerInformationProgressCardVictoryPointView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationProgressCardVictoryPointView'
import {UIPlayerAdditionalInformationLayer} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'
import {Sprites} from '../../../../shared/scripts/ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../../../shared/scripts/UIGameSpriteHandler'

export class UIMGamePlayerInformationProgressCardVictoryPointView extends UIGamePlayerInformationProgressCardVictoryPointView {
    protected createMyProgressCardVictoryPointView() {
        this.createOpponentProgressCardVictoryPointView()
    }

    protected createOpponentProgressCardVictoryPointView() {
        const container = this.playerInformation.getContainerForAdditionalPlayerInformation(UIPlayerAdditionalInformationLayer.Layer2)
        const margin = container.height * 0.1

        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trophy)
        const progressCardVictoryPointW = container.width * 0.25
        const progressCardVictoryPointH = texture.height * progressCardVictoryPointW / texture.width

        const progressCardVictoryPointX = container.width * 0.39
        const progressCardVictoryPointY = 0.75 * margin

        const progressCardVictoryPointCountX = progressCardVictoryPointX
        const progressCardVictoryPointCountY = progressCardVictoryPointY + progressCardVictoryPointH - 0.66 * margin
        const progressCardVictoryPointCountW = progressCardVictoryPointW
        const progressCardVictoryPointCountH = GameFont.Size.Normal + 2 * margin

        const iconPadding = 0
        this.progressCardVictoryPointView = new ItemCountView(progressCardVictoryPointX, progressCardVictoryPointY, progressCardVictoryPointW, progressCardVictoryPointH, container, texture,
            progressCardVictoryPointCountX, progressCardVictoryPointCountY, progressCardVictoryPointCountW, progressCardVictoryPointCountH, iconPadding, GameFont.Size.Normal, GameColor.getColor(GameColor.Color.White))
    }
}
